import { useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';

import usePublicApiQuery from '@/hooks/api/usePublicApiQuery';
import { PublicApiApp } from '@/models/App';
import { SimpleErrorResponse } from '@/models/Error';
import { PublicApiPagedResponse } from '@/models/network';

const SEARCH_RESULT_LIMIT = 5;

const useSearch = () => {
  const [query, setQuery] = useState('');

  const [debouncedQuery] = useDebounceValue(query, 500);

  const { data: pagedData, isLoading } = usePublicApiQuery<PublicApiPagedResponse<PublicApiApp>, SimpleErrorResponse>(
    ['search apps', debouncedQuery],
    `/v0.1/apps?limit=${SEARCH_RESULT_LIMIT}&title=${debouncedQuery}&sort_by=last_build_at`,
    { enabled: !!debouncedQuery },
  );

  const appList = pagedData?.data;

  return { query, setQuery, appList, isLoading };
};

export default useSearch;
